module.exports = __webpack_public_path__ + "static/img/huanzhe3.5181d602.webp";